import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Page from "./components/Page.vue";
import Gap from "./components/base/Gap.vue";
import "./styles/common.scss";
import "./styles/animation.scss";
import "vant/es/toast/style";

import "vant/lib/index.css";
import { setupStore } from "./store";
import { setupDirective } from "./directive";
import { setupWebTrack } from "@/hooks/useTracker";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  init,
  // initDocHeight
} from "./utils/initUtil";
import { Notify } from "vant";
import { initPwa } from "@/utils/pwaGuide/pwaGuide";
import Mixins from "./mixins/global";
import { setupI18n } from "./lang";
import { isInNative } from "./utils/nativeCall/nativeCall";
import { cleanupStalePagePopupHistory } from "@/layouts/pagePopupLayoutHelper";
// import vconsole from "vconsole";

const requireContext = require.context("./assets/icons", false, /\.svg$/);
requireContext.keys().forEach(requireContext);
dayjs.extend(utc);
dayjs.extend(timezone);
const app = createApp(App);

setupWebTrack(app);
setupStore(app);
setupI18n(app);
setupDirective(app);

app.use(Notify);
app.component("Page", Page).component("Gap", Gap).use(router);
// // use vconsole
// const vConsole = new vconsole();
// app.use(vConsole);

// 初始化Android 安装提示
if (!isInNative()) {
  initPwa("android");
}

init().finally(() => {
  // initDocHeight();
  // 初始化iOS 安装提示
  if (!isInNative()) {
    initPwa("ios");
  }
  app.mount("#app");
  document.getElementById("loading")?.remove();
});

// 刷新只会重置内存中的弹窗状态，刷新前 PagePopupLayout 通过 pushState 压入的历史记录
// 仍留在会话历史栈里，用户要多按几次物理返回键才能真正离开当前页。
// 放在首次导航（含 beforeEach 里的登录重定向）落定后处理，避免和 router 抢同一条历史记录
router.isReady().then(() => {
  cleanupStalePagePopupHistory();
});

if (!isInNative() && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js");
}
app.mixin(Mixins);
